// import store from '@/store';
import globals from '@/globals';

function initImperiaLayout(context, threePanel = false) {
  const detail = { config: {} };

  if (threePanel) {
    detail.options = {
      east__initClosed: '1',
      east__maxSize: '400',
      east__resizerCursor: 'ew-resize',
      east__size: '25%',
      fxName: 'slide',
      fxSpeed: 'slow',
      slideTrigger_close: 'click',
      slideTrigger_open: 'click',
      spacing_closed: 10,
      spacing_open: 10,
      west__maxSize: '800',
      west__resizerCursor: 'ew-resize',
      west__size: '25%',
    };
  } else {
    detail.config.two_panel = 1;
  }

  globals.context.dispatchEvent(new CustomEvent('@ui-layout-init', { detail }));
}

export default {
  initImperiaLayout,
};
